export function getLoginDetails()
{
	var userInfo = {};

	var usr = JSON.parse(localStorage.getItem("userInfo"));

	var p_ = localStorage.getItem("p");

	userInfo.Email = usr.Email;

	userInfo.Password = p_.split("").reverse().join("");

	return userInfo;
		
}
export function removeDuplicates(arr) {
  var a = [];
    for (var i=0, l=arr.length; i<l; i++)
        if (a.indexOf(arr[i]) === -1 && arr[i] !== '')
            a.push(arr[i]);
    return a;
}

export function set(key,value)
{
	localStorage.setItem(key.toString().trim(),JSON.stringify(value));
}

export function get(key)
{
	//console.log(key);
	
	if(key)
	{
		return JSON.parse(localStorage.getItem(key));
	}
	else
	{
		return "";
	}
}

export function myFriends(store){

	var myF = store.cryodexGroups.data ? store.cryodexGroups.data : null;
	
	var list = [];
	
	if(myF != null)
	{
		if(myF.length > 0)
		{
			let i;
			
			for(i = 0; i < myF.length ; i++)
			{
				
				let j;
				
				const crys = myF[i].cryodexes;
				
				if(crys)
				{	
					for(j=0; j<crys.length; j++)
					{
						if(crys[j] != null)
						{
							if(list)
							{	
								if (!list.includes(crys[j].Cryodex_ID)) 
								{
									list.push(crys[j]);
									
								}
							}
						}
					}
				}
			}
		}
	}
	
	return list;
}

export function myPlaces(store){

	var myF = store.infodexGroups.data ? store.infodexGroups.data : null;
	
	var list = [];
	
	if(myF != null)
	{
		if(myF.length > 0)
		{
			let i;
			
			for(i = 0; i < myF.length ; i++)
			{
				
				let j;
				
				const crys = myF[i].infodexes;
				
				if(crys)
				{
								
					for(j=0; j<crys.length; j++)
					{	
						if(crys[j] != null)
						{
							if(list)
							{	
								if (!list.includes(crys[j].Infodex_Group_ID)) 
								{
									list.push(crys[j]);
									
								}
							}
						}
					}
				}
			}
		}
	}
	
	return list;
}

export function commonFriends(friendFriends,myFriends)
{
	var result = [];
	
	friendFriends.filter(function(n){
		result = (myFriends.indexOf(n) !== -1);
	});

	return result;	
}

export function commonPlaces(friendPlaces,myPlaces)
{
	var result = [];
	
	friendPlaces.filter(function(n){
		result = (myPlaces.indexOf(n) !== -1);
	});

	return result;
}

		
export function clearStorage(){
		
	localStorage.removeItem("userInfo");
	localStorage.removeItem("cryodex_id");
	localStorage.removeItem("cryodex_profile_image");
	localStorage.removeItem("navUrl");
	localStorage.removeItem("nav");
	localStorage.removeItem("state");
	localStorage.removeItem("selectedCryodexGroup");
	localStorage.removeItem("cryodexGroups");
	localStorage.removeItem("allInfodexGroups");
	localStorage.removeItem("cryodexDefaultGroupId");

}
export function loggedOut(){
	var infod = JSON.parse(localStorage.getItem("store"))?
	JSON.parse(localStorage.getItem("store")):null;

	if(infod != null)
	{
		if(Object.keys(infod.user).length < 1)
		{
			
			return true;
		}
		else 
		{
			return false;
		}
	}
}
export function setUserID(){
	var infod = JSON.parse(localStorage.getItem("store"))?
	JSON.parse(localStorage.getItem("store")):null;
	if(infod != null)
	{
		if(Object.keys(infod.user).length > 0)
		{
			localStorage.setItem("cryodex_id",infod.user.data.Cryodex_ID);
		}
	}
}
export function getGPS(){

    const geolocation = navigator.geolocation;
    
    const location = new Promise((resolve, reject) => {
      
	  if (!geolocation) {

		console.log("Sorry your GPS location tracking is not working. Turn it on using 1. your browser settings, 2. also on your device settings. This app using it. Thank you.");
        console.log(new Error('Not Supported'));
		return 0;
      }
 
      geolocation.getCurrentPosition((position) => {

        resolve(position);
      }, () => {
			console.log("Sorry your GPS location tracking is not working. Turn it on using 1. your browser settings, 2. also on your device settings. This app using it. Thank you.");      
			console.log(new Error('Permission denied'));
		return 0;
      });
    });

    location.then((e) => {		
      const locationObject = {
        longitude: e.coords.longitude,
        latitude: e.coords.latitude
      }	  
	  localStorage.setItem('gps',JSON.stringify(locationObject));
    })
}

 export function distanceB(lat1,lon1,lat2,lon2){
	 
	if ((lat1 == lat2) && (lon1 == lon2)) {
		return 0;
	}
	
	if ((!lat1)||(!lat2)||(!lon1)||(!lon2)) {
		return -1;
	}
   
    var R = 6371; 
	
    var dLat = (lat2-lat1) * Math.PI / 180;
	
    var dLon = (lon2-lon1) * Math.PI / 180;
	
    var a = Math.sin(dLat/2) * Math.sin(dLat/2) +
			Math.cos(lat1 * Math.PI / 180 ) * Math.cos(lat2 * Math.PI / 180 ) *
			Math.sin(dLon/2) * Math.sin(dLon/2);
			
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
	
    var d = R * c;
	
    if (d<=1) return Math.round(d*1000); 
	 
    return Math.round(d * 1000);
	
  }    
 
 export function notDefined(object){
	if(!object)
	{
		alert("Sorry we are missing some data, Try reloading the app.");
		
		return;
	}

}

export function imageUrlEmpty(url){

if(url)
{
	url = url.toLowerCase();
	
	if(
		url.toString().includes("jpg")||
		url.toString().includes("jpeg")||
		url.toString().includes("gif")||
		url.toString().includes("png")
	)
	{	

		return true;
	}
	else
	{
		
		return false;
	}
}
else
{
	return false;
}
		
}

export function imageUrl(url,BACKEND_PUBLIC,IMAGE_DEFAULT){
	
	if(url)
	{
		var rootImageUrlArray = url.split('/'); 
					 
		var lastElement = rootImageUrlArray[rootImageUrlArray.length-1];
		
		var imageUrlCorrect = BACKEND_PUBLIC+lastElement.trim(); 
		
		  var elem = document.createElement('img');
		  
		  elem.style.display = 'none';
		  
		  elem.src = imageUrlCorrect;
				  
		  if(elem.getAttribute('src') == "")
		  {
		
			imageUrlCorrect = IMAGE_DEFAULT;
		  }
		  else
		  {
			  try
			  {
					var img = new Image();
					
					img.src = imageUrlCorrect;
					
					if(img.height != 0)
					{
						//
					}
					else
					{
						imageUrlCorrect = BACKEND_PUBLIC+lastElement.trim();

					}
			  }
			  catch(error)
			  {
				  imageUrlCorrect = BACKEND_PUBLIC+lastElement.trim();

			  }
		 }
	 
	 return imageUrlCorrect;
	}
	return;
}